module.exports = __webpack_public_path__ + "static/img/produto_p.0bb23c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_tubaina/produto_p.png
// module id = zDlj
// module chunks = 0